/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import ParticipationRate from '../ParticipationRate';

/**
 * Headline metric cards for the Bio Vitals page (029 US1 + US3) on the shared au-card
 * design system. Total BP / Sugar / Oxygen / Salt / Water (each with its feature-024
 * participation rate, a link to its type-wide detail list, and a period-over-period
 * delta) plus Total Users (participation rate + "Subscribed" count + delta). Deltas
 * are text + icon, never colour alone.
 */
const ICONS = { up: '▲', down: '▼', flat: '→', new: '★' };
const DELTA_CLASS = { up: 'au-delta--up', down: 'au-delta--down', flat: 'au-delta--flat', new: 'au-delta--flat' };

const VITALS = [
  { key: 'bp', label: 'Total BP', totalKey: 'total_bp_count', deltaKey: 'total_bp', splitKey: 'bp_user_count', link: '/bp-details' },
  { key: 'sugar', label: 'Total Sugar', totalKey: 'total_sugar_count', deltaKey: 'total_sugar', splitKey: 'sugar_user_count', link: '/sugar-details' },
  { key: 'oxygen', label: 'Total Oxygen', totalKey: 'total_oxygen_count', deltaKey: 'total_oxygen', splitKey: 'oxygen_user_count', link: '/oxygen-details' },
  { key: 'salt', label: 'Total Salt', totalKey: 'total_salt_count', deltaKey: 'total_salt', splitKey: 'salt_user_count', link: '/salt-details' },
  { key: 'water', label: 'Total Water', totalKey: 'total_water_count', deltaKey: 'total_water', splitKey: 'water_user_count', link: '/water-details' },
];

const n = (v) => Number(v || 0).toLocaleString();

const Delta = ({ delta }) => {
  if (!delta || !delta.direction) return null;
  const { direction, delta_pct: pct } = delta;
  const pill = direction === 'new'
    ? `${ICONS.new} New`
    : direction === 'flat'
      ? `${ICONS.flat} 0%`
      : `${ICONS[direction]} ${Math.abs(pct)}%`;
  const label = direction === 'new' ? 'this period' : 'vs prior period';
  return (
    <span className="bv-delta" aria-label={`${pill} ${label}`}>
      <span className={`au-delta ${DELTA_CLASS[direction]}`}>{pill}</span>
      <span className="bv-delta__lbl">{label}</span>
    </span>
  );
};

const BioVitalsSummaryCards = ({
  totals = {},
  splitCounts = {},
  totalUserBase = 0,
  totalUsers = 0,
  subscribedUserCount = 0,
  deltas = {},
}) => (
  <div className="au-cards" data-testid="bv-summary">
    {VITALS.map((v) => (
      <Link key={v.key} to={v.link} className="au-card-link" style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="au-card">
          <span className="au-card__label">{v.label}</span>
          <span className="au-card__value tnum">{n(totals[v.totalKey])}</span>
          <ParticipationRate className="au-card__sub" count={splitCounts[v.splitKey]} total={totalUserBase} />
          <Delta delta={deltas[v.deltaKey]} />
        </div>
      </Link>
    ))}
    <div className="au-card">
      <span className="au-card__label">Total Users</span>
      <span className="au-card__value tnum">{n(totalUsers)}</span>
      <ParticipationRate className="au-card__sub" count={totalUsers} total={totalUserBase} />
      <span className="au-card__sub" data-testid="bv-subscribed">Subscribed: {n(subscribedUserCount)}</span>
      <Delta delta={deltas.total_users} />
    </div>
  </div>
);

export default BioVitalsSummaryCards;
